export function findTextBetweenTwoSeparators(text, start, end) {
  const textFound = text.substring(text.indexOf(start) + start.length, text.lastIndexOf(end))
  return textFound
}

export function findElementByTags(text, startTag, endTag) {
  const textFound = text.substring(text.indexOf(startTag) + startTag.length, text.lastIndexOf(endTag))
  return textFound
}

export function containsMoreThanLinks(htmlString) {
  if (!htmlString) return null

  let textContent = null

  const regex = /<[^>]+>/gi // Regular expression to match HTML tags
  const tags = htmlString.match(regex)
  if (tags && tags.length > 0) {
    const tag = tags[0] + findTextBetweenTwoSeparators(htmlString, tags[0], tags[1]) + tags[1]
    textContent = htmlString.replace(tag, "") // Remove HTML tags
  } else {
    textContent = htmlString
  }

  // Check if there is any non-whitespace text content remaining
  const hasMoreThanATag = /\S/.test(textContent)
  return hasMoreThanATag
}
